import classnames from "classnames";
import * as React from "react";

import WithLink from "features/common/components/WithLink";

import PrimaryButton, { PrimaryButtonColorProps } from "./PrimaryButton";
import styles from "./PrimaryButtonPremium.module.scss";

type Props = PrimaryButtonColorProps;

export default function PrimaryButtonPremium({ className, ...props }: Props) {
  return (
    <PrimaryButton
      {...props}
      primaryButtonColorClassName={classnames(className, styles.button)}
    />
  );
}

export const PrimaryButtonPremiumWithLink = WithLink(PrimaryButtonPremium);
